import { MutableRefObject, useRef } from "react";
import { Button, Modal } from "react-bootstrap";

interface ITermConditionModal {
  show: boolean;
  onHide: any;
  onOk: any;
}

const TermConditionModal = (props: ITermConditionModal) => {
  const okButtonEl = useRef() as MutableRefObject<HTMLButtonElement>;

  return (
    <Modal show={props.show} size='lg' onHide={props.onHide} centered /*onEntered={() => okButtonEl?.current?.focus()}*/>
      <Modal.Body className='text-14'>
        <h2>Terms &amp; Conditions</h2>
        <b>Terms &amp; Conditions (For Vehicle Booking Only)</b>
        <ul>
          <li>24 hours advance booking, subject to availability</li>
          <li>Payment mode: Credit Card only</li>
          <li>Additional $10 for Wheelchair Accessible Van for Weekends and PH</li>
          <li>Midnight surcharge is from 2300 hrs to 0659 hrs:</li>
          <li>$12 for London cab and Limousine</li>
          <li>$20 for Wheelchair Accessible Van</li>
          <li>Waiting charge is $15 per 15-minutes block (All vehicle types)</li>
          <li>Airport Transfer (Arrival): No charge for the first 45 minutes based on the actual landing time of flight, additional $15 for subsequent block 15 minutes (All vehicle types)</li>
          <li>Extended Hourly Disposal (per 15-minutes block): Pro-rated/block (For hourly charter)</li>
          <li>Additional stop: $10 (within 3 km)</li>
        </ul>

        <b>Amendment charge:</b>
        <ul>
          <li>$10 per amendment within 2 hours and more than 45 mins prior to pickup time</li>
          <li>Amendment charges apply for changes to pickup location/destination, time and/or date</li>
          <li>Up to maximum of 2 amendments allowed after booking is made</li>
          <li>No amendment is allowed less than 45 mins of pickup time</li>
          <li>1 amendment allowed when trip has started but only for extension in Hourly charter hours and change in Return Trip timing.</li>
          <li>No amendments allowed for i) Vehicle type ii) Service type iii) Additional Stops after booking is made</li>
          <li>There will be no charge if amendment is made more than 2 hours</li>
          <li>After booking confirmation, any amendments will be rejected if amendment payment fails</li>
          <li>Strides Premier Private Hire and Limousine reserves the right to change the driver/vehicle at any point/ in the event if the original driver is not able to fulfil the booking after amendment is made</li>
        </ul>

        <b>Cancellation charge:</b>
        <ul>
          <li>Full charge for cancellation made within 2 hours prior to pickup time</li>
          <li>$10 charge when cancellation is made between 2 to 4 hours prior to pickup time</li>
          <li>$5 admin charge when cancellation is made more than 4 hours prior to pickup time</li>
          <li>In case of lateness by passenger or Passenger No Show (PNS) for non-airport arrival trip, and driver is unable to contact the passenger, driver will leave after 15 minutes after their respective transfer waiting time. Thereafter, the booking will be considered completed/fulfilled and the full fare will be charged.</li>
        </ul>

        <b>Terms &amp; Conditions (For Vehicle + Caregiver Booking)</b>
        <ul>
          <li>24 hours advance booking, subject to availability</li>
          <li>Additional $3 for Caregiver Urgent booking is booking is made less than 24 hours</li>
          <li>Payment mode: Credit Card only</li>
          <li>Charges above apply for pickup time between 0700 to 2300 hrs (Mon to Fri, excl. PH);</li>
          <li>Additional $10 for Wheelchair Accessible Van for Weekends and PH</li>
          <li>Additional $15 for Caregiver service on eve of PH and PH</li>
          <li>Midnight surcharge is from 2300 hrs to 0659 hrs:</li>
          <li>$12 for London cab and Limousine</li>
          <li>$20 for Wheelchair Accessible Van</li>
          <li>$30 for Caregiver Service</li>
          <li>Waiting charge is $15 per 15-minutes block (All vehicle types)</li>
          <li>Airport Transfer (Arrival): No charge for the first 45 minutes based on the actual landing time of flight, additional $15 for subsequent block 15 minutes (All vehicle types)</li>
          <li>Extended Hourly Disposal (per 15-minutes block): Pro-rated/block (For hourly charter)</li>
          <li>Additional stop: $10 (within 3 km)</li>
        </ul>

        <b>Amendment charges:</b>
        <ul>
          <li>$12 per amendment within 12 hours and 48 hours prior to pickup time</li>
          <li>Amendment charges apply for changes to pickup location/destination, time and/or date</li>
          <li>Up to maximum of 2 amendments allowed after booking is made</li>
          <li>No amendment is allowed within 12 hours prior to pickup time</li>
          <li>1 amendment allowed when trip has started but only for extension in Hourly charter hours and change in Return Trip timing.</li>
          <li>No amendments allowed for i) Vehicle type ii) Service type iii) Pickup location iv) Additional Stops after booking is made</li>
          <li>There will be no charge if amendment is made more than 48 hours</li>
          <li>After booking confirmation, any amendments will be rejected if amendment payment fails</li>
          <li>Strides Premier Private Hire and Limousine reserves the right to change the driver/vehicle at any point/ in the event if the original driver is not able to fulfil the booking after amendment is made</li>
        </ul>

        <b>Cancellation charge:</b>
        <ul>
          <li>Full charge for cancellation made within 12 hours prior to pickup time</li>
          <li>$27 charge when cancellation is made between 12 to 48 hours prior to pickup time</li>
          <li>$5 admin charge when cancellation is made more than 48 hours prior to pickup time</li>
          <li>In case of lateness by passenger or Passenger No Show (PNS) for non-airport arrival trip, and driver is unable to contact the passenger, driver will leave after 15 minutes after their respective transfer waiting time. Thereafter, the booking will be considered completed/fulfilled and the full fare will be charged.</li>
        </ul>
        <div className='text-center'>
          <Button variant="danger" className="mr-2 text-15 font-weight-bold" onClick={() => props.onOk()}
            ref={okButtonEl}
            tabIndex={-1} // Enables key handlers on div
          >OK</Button>
        </div>
      </Modal.Body>
    </Modal >
  );
}

export default TermConditionModal;
